import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { HomeServiceOrderUpdateInput } from '@/models/homeService';

export const updateHomeServiceOrder = async ({
  id,
  data,
  sendMemberPoliciesEmail,
}: {
  id: number;
  data: HomeServiceOrderUpdateInput;
  sendMemberPoliciesEmail?: boolean;
}) => {
  const response = await mutationExecute({
    variables: {
      id,
      data,
      sendMemberPoliciesEmail,
    },
    mutation: graphql(`
      mutation UpdateHomeServiceOrder($id: Float!, $data: HomeServiceOrderUpdateInputType!, $sendMemberPoliciesEmail: Boolean) {
        updateHomeServiceOrder(id: $id, data: $data, sendMemberPoliciesEmail: $sendMemberPoliciesEmail) {
          id
        }
      }
    `),
  });

  return response.data?.updateHomeServiceOrder;
};
